/* eslint-disable @typescript-eslint/no-unused-vars */
import { CircularProgress } from "@mui/material";
import { useTranslations } from "use-intl";

import { type SingleFightDetailsData } from "@/app/lib/context/SingleFlightDetailsContext";
import type { GetFlightAvailabilityTokenAdditionalService } from "@/app/lib/types/codegen";
import { isBaggageService } from "../lib/utils/baggageProcessor";
import { ExpandableSection } from "./ExpandableSection";

type Props = {
  singleFlightDetails?: SingleFightDetailsData;
  isAdditionalDataLoading: boolean;
};

function AdditionalInfoCard({
  singleFlightDetails,
  isAdditionalDataLoading,
}: Props) {
  const t = useTranslations();
  const processedServices = [
    ...(singleFlightDetails?.mandatoryServices || []),
    ...(singleFlightDetails?.optionalServices || []),
  ]
    .filter((service) => !isBaggageService(service))
    .reduce((acc, service) => {
      // remove duplicates based on service name
      if (!acc.find((item) => item.service.name === service.service.name)) {
        acc.push(service);
      }
      return acc;
    }, [] as GetFlightAvailabilityTokenAdditionalService[]);

  return (
    <>
      <div className="section-title mt-4">{t("flights.additionalInfo")}</div>
      {/* hidden for now, as the whole section is misleading */}
      {/* https://netguru.atlassian.net/browse/DZR-772 */}
      {/* <div className="section-card flex gap-4">
        {isAdditionalDataLoading ? (
          <div className="flex w-full items-center gap-2 text-sm font-normal text-text-primary">
            <CircularProgress size={20} />
            {t("flights.retrievingDetails")}
          </div>
        ) : (
          <>
            {processedServices.length > 0 ? (
              <div className="flex w-full flex-col gap-2">
                <h3 className="text-sm font-semibold text-text-primary">
                  {t("flights.offerDetails")}
                </h3>
                {processedServices.map((service) => (
                  <p
                    key={service.service.name}
                    className="text-sm font-normal text-text-primary"
                  >
                    {service.service.name}{" "}
                    {service.included ? t("flights.included") : null}
                  </p>
                ))}
              </div>
            ) : (
              <div className="flex w-full items-center gap-2 text-sm font-normal text-text-primary">
                {t("flights.noDetails")}
              </div>
            )}
          </>
        )}
      </div> */}

      <div className="section-card mt-2">
        <ExpandableSection>
          <div className="flex w-full flex-col gap-2">
            <h3 className="text-sm font-medium text-text-primary">
              {t("flights.baggage.regulationsOnSpecialBaggage")}
            </h3>
            <p className="text-sm font-normal text-text-primary">
              {t("flights.regulationsDetails")}
            </p>
          </div>
        </ExpandableSection>
      </div>
    </>
  );
}

export default AdditionalInfoCard;
